export default __webpack_public_path__ + "static/media/info-arrow-up-neg.ef6bf0ec.svg";